import styled from 'styled-components/macro'
import { media } from '../../../ui/rwd'

const NavigationWrapper = styled.div`
  display: flex;
  flex-direction: row;
  max-width: 100vw;
  flex-wrap: wrap;
  justify-content: center;
  ${media.md`
    justify-content: flex-end;
  `}
`

export { NavigationWrapper }
